/* MiniKin homepage v2 — motion and interactions.
   Reveal once, small stagger, click dropdown, tabs, accordion, signup validation.
   Everything degrades to plain visible content without this file. */
(() => {
  'use strict';
  window.__k = true;
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => [...c.querySelectorAll(s)];
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const fine = matchMedia('(hover:hover) and (pointer:fine)').matches;

  /* reveal: each block fades up once; grouped cards follow each other 50ms apart */
  $$('[data-k-stagger]').forEach((g) => [...g.children].forEach((el, i) => el.style.setProperty('--kd', Math.min(i, 8) * 50 + 'ms')));
  const els = $$('[data-k-reveal],[data-k-stagger]>*');
  const show = (el) => {
    el.classList.add('in');
    /* once it has arrived, hand the element back to its own hover transition */
    setTimeout(() => { el.classList.add('k-rest'); el.style.removeProperty('--kd'); }, 1100);
  };
  if (reduce || !('IntersectionObserver' in window)) els.forEach(show);
  else {
    const io = new IntersectionObserver((es) => es.forEach((e) => { if (e.isIntersecting) { show(e.target); io.unobserve(e.target); } }), { threshold: 0.1, rootMargin: '0px 0px -5% 0px' });
    els.forEach((el) => io.observe(el));
  }

  /* collections dropdown: opens on click, and on hover after a short pause; Escape or an outside click closes it */
  const dd = $('[data-k-dd]');
  if (dd) {
    const btn = $('button', dd), panel = $('[data-k-dd-panel]', dd);
    let t = 0;
    const open = () => dd.classList.contains('is-open');
    const set = (o) => { dd.classList.toggle('is-open', o); btn.setAttribute('aria-expanded', o); };
    btn.addEventListener('click', () => { clearTimeout(t); set(!open()); });
    if (fine) {
      dd.addEventListener('mouseenter', () => { clearTimeout(t); t = setTimeout(() => set(true), 140); });
      dd.addEventListener('mouseleave', () => { clearTimeout(t); t = setTimeout(() => set(false), 220); });
    }
    document.addEventListener('click', (e) => { if (!dd.contains(e.target)) set(false); });
    dd.addEventListener('focusout', (e) => { if (e.relatedTarget && !dd.contains(e.relatedTarget)) set(false); });
    document.addEventListener('keydown', (e) => {
      if (!open()) return;
      if (e.key === 'Escape') { set(false); btn.focus(); return; }
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        const links = $$('a', panel), i = links.indexOf(document.activeElement);
        e.preventDefault();
        links[(i + (e.key === 'ArrowDown' ? 1 : -1) + links.length) % links.length].focus();
      }
    });
  }

  /* tabs: click or arrow keys; nothing moves on its own */
  $$('[data-k-tabs]').forEach((root) => {
    const tabs = $$('[role=tab]', root), panels = $$('[role=tabpanel]', root);
    const pick = (i, focus) => {
      tabs.forEach((tb, k) => { tb.setAttribute('aria-selected', k === i); tb.tabIndex = k === i ? 0 : -1; });
      panels.forEach((p, k) => { p.classList.toggle('is-on', k === i); k === i ? p.removeAttribute('inert') : p.setAttribute('inert', ''); });
      if (focus) tabs[i].focus();
    };
    tabs.forEach((tb, i) => {
      tb.addEventListener('click', () => pick(i));
      tb.addEventListener('keydown', (e) => {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        e.preventDefault(); pick((i + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length, true);
      });
    });
  });

  /* accordion: the button names its panel with aria-controls */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('.k-acc__btn'); if (!b) return;
    const o = b.getAttribute('aria-expanded') !== 'true';
    const p = document.getElementById(b.getAttribute('aria-controls')), item = b.closest('.k-acc__item');
    b.setAttribute('aria-expanded', o);
    if (item) item.classList.toggle('is-open', o);
    if (p) o ? p.removeAttribute('inert') : p.setAttribute('inert', '');
  });

  /* email signup: check the address, show a sending state, then let the form post normally
     (Shopify adds its bot-check on the way; the success message is rendered by the server) */
  const f = $('[data-k-signup]');
  if (f) {
    const inp = $('input[type=email]', f), msg = $('[data-k-msg]', f), btn = $('button[type=submit]', f);
    if (inp && msg && btn) f.addEventListener('submit', (e) => {
      const v = inp.value.trim();
      if (!/^[^@ ]+@[^@ ]+[.][^@ ]{2,}$/.test(v)) {
        e.preventDefault(); e.stopImmediatePropagation();
        inp.setAttribute('aria-invalid', 'true');
        msg.textContent = 'Please enter a valid email address.'; msg.hidden = false; inp.focus();
        return;
      }
      inp.value = v; inp.removeAttribute('aria-invalid'); msg.hidden = true;
      btn.classList.add('is-busy'); btn.textContent = 'Sending…';
    }, true);
  }

  /* optional slow loop inside the hero placeholder: off by default, only offered in the theme editor */
  const lp = $('[data-k-loop]');
  if (lp) {
    const b = $('[data-k-loop-btn]');
    let on = false;
    const set = (o) => {
      on = o && !reduce; lp.classList.toggle('is-run', on);
      if (b) { b.setAttribute('aria-pressed', on); b.textContent = on ? 'Pause motion preview' : 'Preview slow motion loop'; }
    };
    if (b) b.addEventListener('click', () => set(!on));
    if ('IntersectionObserver' in window) new IntersectionObserver(([e]) => lp.classList.toggle('is-off', !e.isIntersecting)).observe(lp);
  }
})();